









import { Component, Prop, Vue } from 'vue-property-decorator';
import DiceHelpDialog from '@/browser/moleculers/DiceHelpDialog.vue';
import Member from '@/models/Member';
import MemberListDialog from '@/browser/moleculers/MemberListDialog.vue';
import Members from '@/models/Members';
import Room from '@/models/Room';
import RoomCreatedAtChip from '@/browser/moleculers/RoomCreatedAtChip.vue';
import RoomDiceChip from '@/browser/atoms/RoomDiceChip.vue';
import RoomMembersChip from '@/browser/atoms/RoomMembersChip.vue';

@Component({
  components: {
    DiceHelpDialog,
    MemberListDialog,
    RoomCreatedAtChip,
    RoomDiceChip,
    RoomMembersChip,
  },
})
export default class RoomInfoList extends Vue {
  @Prop() members?: Members;
  @Prop({ required: true }) room!: Room;

  helpOpen: boolean = false;
  membersOpen: boolean = false;

  get memberList(): Member[] {
    const {
      members,
    } = this;

    return members ? Object.keys(members)
      .filter(key => (typeof members[key] === 'object'))
      .map(key => ({ ...members[key], uid: key }))
      .sort((a, b) => a.updatedAt - b.updatedAt) : [];
  }
}
